// removed by extract-text-webpack-plugin
module.exports = {"bar":"_1M8_4P1UwEcUfHDHqgVnOy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsList/SongsListSearchBar.scss
// module id = 1319
// module chunks = 1